export * from './dataMapperConfig'
export const DOUBLE_CLICK_MS = 100

export enum MouseButtons {
  Left   = 1,
  Right  = 2,
  Middle = 4 // My scroll wheel clicked
}
export * from './queryFragmentStrings'

export const UNASSIGNED = 'unassigned'



// WEBPACK FOOTER //
// ./src/modules/common/constants/index.ts